import { render, staticRenderFns } from "./ProductLightbox.vue?vue&type=template&id=0cf709d6"
import script from "./ProductLightbox.vue?vue&type=script&lang=js"
export * from "./ProductLightbox.vue?vue&type=script&lang=js"
import style0 from "./ProductLightbox.vue?vue&type=style&index=0&id=0cf709d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports